import { PERMISSIONS, ROLE_CONFIG_KEYS } from "common/constants";
import { useAuthContext } from "common/contexts/AuthContext";
import Support from "common/icons/HelpGreen.svg";
import Profile from "common/icons/ProfileGreen.svg";
import { filterConfigElements } from "common/utils";
import { t } from "i18next";
import { useMemo } from "react";
import styled from "styled-components";
import CartHeader from "./CartHeader";
import CustomHeader from "./CustomHeader";
import NotificationHeader from "./NotificationHeader";
import PhoneHeader from "./PhoneHeader";
import SelectedRoleHeader from "./SelectedRoleHeader";

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  border-bottom: 1px solid rgba(0, 87, 84, 0.1);
  height: 5vh;
`;

const headersConfig = [
  {
    component: <SelectedRoleHeader key="profileName" />,
    permission: { key: ROLE_CONFIG_KEYS.profile, value: PERMISSIONS.read }
  },
  {
    component: <SelectedRoleHeader key="selectedRole" />,
    permission: { key: ROLE_CONFIG_KEYS.roleSwitch, value: PERMISSIONS.create }
  },
  {
    component: <PhoneHeader key="phoneheader" />,
    permission: { key: ROLE_CONFIG_KEYS.notifications, value: PERMISSIONS.read }
  },
  {
    component: (
      <CustomHeader
        to="/profile"
        title={t("profile")}
        image={Profile}
        activeImage={Profile}
        key="profile"
      />
    ),
    permission: { key: ROLE_CONFIG_KEYS.profile, value: PERMISSIONS.read }
  },
  {
    component: (
      <CustomHeader
        to="/support"
        title={t("help_support")}
        image={Support}
        activeImage={Support}
        key="support"
      />
    ),
    permission: { key: ROLE_CONFIG_KEYS.profile, value: PERMISSIONS.read }
  },
  {
    component: <NotificationHeader key="notifications" />,
    permission: { key: ROLE_CONFIG_KEYS.notifications, value: PERMISSIONS.read }
  },
  {
    component: <CartHeader key="cart" />,
    permission: { key: ROLE_CONFIG_KEYS.cart, value: PERMISSIONS.read }
  }
];

const Header = () => {
  const { parsedRoleConfig } = useAuthContext();
  const userHeaderElements = useMemo(
    () => filterConfigElements(parsedRoleConfig, headersConfig),
    [parsedRoleConfig]
  );
  return (
    <div>
      <HeaderContainer>{userHeaderElements}</HeaderContainer>
    </div>
  );
};

export default Header;
